import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, change } from 'redux-form';
import first from 'lodash/first';
import partial from 'lodash/partial';
import idx from 'idx';
import isEmail from 'sane-email-validation';
import { sendAgencyContact, toggleChat } from 'help/ducks/contact';
import Contact from 'marketing/components/consultation_agencies';
import {
  HELP_FORM, INVALID_EMAIL, NAME_REQUIRED, MESSAGE_REQUIRED,
  PHONE_REQUIRED, CATEGORY_REQUIRED, timeOptions,
} from 'help/constants';


export function validate(values) {
  const errors = {};

  if (!values.full_name) {
    errors.full_name = NAME_REQUIRED;
  }

  if (!values.email || !isEmail(values.email)) {
    errors.email = INVALID_EMAIL;
  }

  if (!values.phone_number) {
    errors.phone_number = PHONE_REQUIRED;
  }

  if (!values.message) {
    errors.message = MESSAGE_REQUIRED;
  }

  return errors;
}

export function mapStateToProps(state) {
  const { help: { contact }, user } = state;
  const initialValues = {
    best_time_to_call: first(timeOptions).field
  };
  const canChat = !user.logged_in || user.profile_data.is_client;

  return {
    ...contact,
    initialValues,
    canChat,
    formName: HELP_FORM,
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    onSubmit: sendAgencyContact,
    toggleChat
  }, dispatch);
}

const ContactForm = reduxForm({
  form: HELP_FORM,
  validate,
})(Contact);

export default connect(mapStateToProps, mapDispatchToProps)(ContactForm);



// WEBPACK FOOTER //
// ./marketing/containers/consultation_agencies.jsx